module.exports = __webpack_public_path__ + "img/11-active.d9cfc7ee.svg";